var _defs, _g, _g2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIdcard({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1080 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#2a0760;}.cls-2{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:30px;}.cls-3{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Back"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 540,
    cy: 540,
    r: 430.35
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "ikon"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 354.38,
    y: 418.09,
    width: 371.25,
    height: 243.81,
    rx: 16.97
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 540.81,
    y1: 481.57,
    x2: 675.87,
    y2: 481.57
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 540.81,
    y1: 540.35,
    x2: 675.87,
    y2: 540.35
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 617.51,
    y1: 599.12,
    x2: 677.14,
    y2: 599.12
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 540.81,
    y1: 599.12,
    x2: 588.06,
    y2: 599.12
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M475.37,534.73a30.93,30.93,0,1,1,13-25.23,30.76,30.76,0,0,1-13,25.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M457.48,556.49v20.9l-30.56,10.23a7.75,7.75,0,0,0-5.3,7.36v4.14h71.72V595a7.75,7.75,0,0,0-5.3-7.36l-30.56-10.23v-25.9"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 457.48,
    cy: 510.75,
    r: 24.67
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 540,
    y1: 361.91,
    x2: 540,
    y2: 421.06
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdcard);
export default __webpack_public_path__ + "static/media/Idcard.f1c6b05e.svg";
export { ForwardRef as ReactComponent };